import { createI18n } from 'vue-i18n'
import { localeEn, localeMe, localeSr, localeBa } from 'app-resources'

// Same messages and locale defaults as old admin (apps/admin/src/i18n.ts):
// locale 'en', fallback 'en'. Runtime locale is set by app-core during init.
const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: { en: localeEn, me: localeMe, sr: localeSr, ba: localeBa },
    missingWarn: false,
    fallbackWarn: false
})

export default i18n
